module.exports = __webpack_public_path__ + "static/media/live-meetings-background.34a23dde.png";